import BreadcrumbTitle from "components/BreadcrumbTitle"
import { SaveButton } from "components/Buttons"
import PageMetaTags from "components/PageMetaTags"
import React, { useEffect, useState } from "react"
import { connect } from "react-redux"
import { withRouter } from "react-router-dom"
import { Col, Row, Container, Spinner } from "reactstrap"
import { getOrderDetails, resetOrderDetails } from "store/actions"
import {
  getFormattedTime,
  isCagerClient,
  isHarvardClient,
  isIfoClient,
  isWesternEdgeClient,
} from "utils"

const OrderDetails = ({
  orderDetails,
  loading,
  history,
  resetOrderDetails,
  match,
  getOrderDetails,
}) => {
  useEffect(() => {
    if (match.params.id) {
      getOrderDetails({ id: match.params.id })
    }
    return () => {
      resetOrderDetails()
    }
  }, [])

  const [detailsAreLoaded, setDetailsAreLoaded] = useState(false)

  useEffect(() => {
    if (!!orderDetails) {
      setDetailsAreLoaded(true)
    }
  }, [orderDetails])

  return (
    <React.Fragment>
      <div className="page-content">
        <PageMetaTags title="Order Details" />
        <Container fluid>
          <BreadcrumbTitle
            title="Order Details"
            breadcrumbItems={[
              { title: "Dashboard" },
              { title: "Order Details" },
            ]}
          />
          <Row className="d-flex justify-content-end mb-2">
            <Col xs="auto">
              <SaveButton
                content="Back"
                type="button"
                onClick={() => {
                  history.goBack()
                }}
              />
            </Col>
          </Row>
          {!detailsAreLoaded ? (
            <Row className="d-flex justify-content-center">
              <Col xs="auto">
                <Spinner />
              </Col>
            </Row>
          ) : (
            <>
              <Row>
                <Col>
                  <table
                    className="text-14"
                    style={{
                      backgroundColor: "#e1edf4",
                      width: "700px",
                      margin: "0 auto",
                      fontSize: "14px",
                    }}
                  >
                    <tbody>
                      {orderDetails?.status === 3 && (
                        <tr>
                          <td colspan="2" className="text-center">
                            <p>
                              <i>ORDER CANCELLED</i>
                            </p>
                          </td>
                        </tr>
                      )}
                      <tr style={{ padding: "5px" }}>
                        <td style={{ padding: "15px" }}>Name</td>
                        <td
                          style={{
                            padding: "15px",
                            backgroundColor: "#f5f5f5",
                          }}
                        >
                          {orderDetails?.first_name}
                          {orderDetails?.last_name}
                        </td>
                      </tr>
                      <tr>
                        <td style={{ padding: "15px" }}>Email</td>
                        <td
                          style={{
                            padding: "15px",
                            backgroundColor: "#f5f5f5",
                          }}
                        >
                          {orderDetails?.email}
                        </td>
                      </tr>
                      {!!orderDetails?.details?.harvard_email && (
                        <tr>
                          <td style={{ padding: "15px" }}>Harvard Email</td>
                          <td
                            style={{
                              padding: "15px",
                              backgroundColor: "#f5f5f5",
                            }}
                          >
                            {orderDetails?.details?.harvard_email}
                          </td>
                        </tr>
                      )}
                      {!!orderDetails?.phone && (
                        <tr>
                          <td style={{ padding: "15px" }}>Phone</td>
                          <td
                            style={{
                              padding: "15px",
                              backgroundColor: "#f5f5f5",
                            }}
                          >
                            {orderDetails?.phone}
                          </td>
                        </tr>
                      )}
                      {isCagerClient() &&
                        !!orderDetails?.details?.business_name && (
                          <tr>
                            <td style={{ padding: "15px" }}>
                              Name of Business
                            </td>
                            <td
                              style={{
                                padding: "15px",
                                backgroundColor: "#f5f5f5",
                              }}
                            >
                              {orderDetails?.details?.business_name}
                            </td>
                          </tr>
                        )}
                      {isCagerClient() &&
                        !!orderDetails?.details?.business_address && (
                          <tr>
                            <td style={{ padding: "15px" }}>
                              Business Address
                            </td>
                            <td
                              style={{
                                padding: "15px",
                                backgroundColor: "#f5f5f5",
                              }}
                            >
                              {orderDetails?.details.business_address}
                            </td>
                          </tr>
                        )}
                      {!!orderDetails?.details?.business_website && (
                        <tr>
                          <td style={{ padding: "15px" }}>Website</td>
                          <td
                            style={{
                              padding: "15px",
                              backgroundColor: "#f5f5f5",
                            }}
                          >
                            {orderDetails?.details.business_website}
                          </td>
                        </tr>
                      )}
                      {!!orderDetails.details.date_of_birth && (
                        <tr>
                          <td style={{ padding: "15px" }}>DOB</td>
                          <td
                            style={{
                              padding: "15px",
                              backgroundColor: "#f5f5f5",
                            }}
                          >
                            {orderDetails?.details.date_of_birth
                              ? orderDetails?.details.date_of_birth.split(
                                  " "
                                )[0]
                              : ""}
                          </td>
                        </tr>
                      )}
                      {!!orderDetails.details.gender && (
                        <tr>
                          <td style={{ padding: "15px" }}>Male/Female</td>
                          <td
                            style={{
                              padding: "15px",
                              backgroundColor: "#f5f5f5",
                            }}
                          >
                            {orderDetails?.details.gender}
                          </td>
                        </tr>
                      )}

                      {!!orderDetails?.details?.occupation && (
                        <tr>
                          <td style={{ padding: "15px" }}>
                            {isWesternEdgeClient()
                              ? "Sport/Occupation"
                              : "Occupation"}
                          </td>
                          <td
                            style={{
                              padding: "15px",
                              backgroundColor: "#f5f5f5",
                            }}
                          >
                            {orderDetails?.details.occupation}
                          </td>
                        </tr>
                      )}

                      {!!orderDetails?.city && (
                        <tr>
                          <td style={{ padding: "15px" }}>City</td>
                          <td
                            style={{
                              padding: "15px",
                              backgroundColor: "#f5f5f5",
                            }}
                          >
                            {orderDetails?.city}
                          </td>
                        </tr>
                      )}

                      {!!orderDetails?.state && (
                        <tr>
                          <td style={{ padding: "15px" }}>State</td>
                          <td
                            style={{
                              padding: "15px",
                              backgroundColor: "#f5f5f5",
                            }}
                          >
                            {orderDetails?.state}
                          </td>
                        </tr>
                      )}

                      {!!orderDetails?.country && (
                        <tr>
                          <td style={{ padding: "15px" }}>
                            {isIfoClient() ? "Country/Timezone" : "Country"}
                          </td>
                          <td
                            style={{
                              padding: "15px",
                              backgroundColor: "#f5f5f5",
                            }}
                          >
                            {orderDetails?.country}
                          </td>
                        </tr>
                      )}

                      {!!orderDetails?.address && (
                        <tr>
                          <td style={{ padding: "15px" }}>Address</td>
                          <td
                            style={{
                              padding: "15px",
                              backgroundColor: "#f5f5f5",
                            }}
                          >
                            {orderDetails?.address}
                          </td>
                        </tr>
                      )}
                      {!!orderDetails?.zip_code && (
                        <tr>
                          <td style={{ padding: "15px" }}>
                            {isIfoClient() ? "Postal Code" : "Zip Code"}
                          </td>
                          <td
                            style={{
                              padding: "15px",
                              backgroundColor: "#f5f5f5",
                            }}
                          >
                            {orderDetails?.zip_code}
                          </td>
                        </tr>
                      )}

                      {!!orderDetails?.details
                        ?.social_media_followers_number && (
                        <tr>
                          <td style={{ padding: "15px" }}>
                            Number of Social Media Followers
                          </td>
                          <td
                            style={{
                              padding: "15px",
                              backgroundColor: "#f5f5f5",
                            }}
                          >
                            {
                              orderDetails?.details
                                .social_media_followers_number
                            }
                          </td>
                        </tr>
                      )}
                      {!isCagerClient() &&
                        !!orderDetails?.details?.business_name && (
                          <tr>
                            <td style={{ padding: "15px" }}>
                              Name of Business/Association
                            </td>
                            <td
                              style={{
                                padding: "15px",
                                backgroundColor: "#f5f5f5",
                              }}
                            >
                              {orderDetails?.details.business_name}
                            </td>
                          </tr>
                        )}

                      {!!orderDetails?.business_type && (
                        <tr>
                          <td style={{ padding: "15px" }}>
                            Type of Business/Association Industry
                          </td>
                          <td
                            style={{
                              padding: "15px",
                              backgroundColor: "#f5f5f5",
                            }}
                          >
                            {orderDetails?.details.business_type}
                          </td>
                        </tr>
                      )}

                      {!isCagerClient() &&
                        !!orderDetails?.details?.business_address && (
                          <tr>
                            <td style={{ padding: "15px" }}>
                              Business/Association Address
                            </td>
                            <td
                              style={{
                                padding: "15px",
                                backgroundColor: "#f5f5f5",
                              }}
                            >
                              {orderDetails?.details.business_address}
                            </td>
                          </tr>
                        )}

                      {!!orderDetails?.details?.social_media &&
                        !isHarvardClient() && (
                          <tr>
                            <td style={{ padding: "15px" }}>Social Media @</td>
                            <td
                              style={{
                                padding: "15px",
                                backgroundColor: "#f5f5f5",
                              }}
                            >
                              {orderDetails?.details.social_media}
                            </td>
                          </tr>
                        )}

                      {!!orderDetails?.details?.college_name && (
                        <tr>
                          <td style={{ padding: "15px" }}>Name of College</td>
                          <td
                            style={{
                              padding: "15px",
                              backgroundColor: "#f5f5f5",
                            }}
                          >
                            {orderDetails?.details.college_name}
                          </td>
                        </tr>
                      )}

                      {!!orderDetails?.details?.team_name && (
                        <tr>
                          <td style={{ padding: "15px" }}>Team Name</td>
                          <td
                            style={{
                              padding: "15px",
                              backgroundColor: "#f5f5f5",
                            }}
                          >
                            {orderDetails?.details.team_name}
                          </td>
                        </tr>
                      )}

                      {!!orderDetails?.details?.age && (
                        <tr>
                          <td style={{ padding: "15px" }}>Age Level</td>
                          <td
                            style={{
                              padding: "15px",
                              backgroundColor: "#f5f5f5",
                            }}
                          >
                            {orderDetails?.details.age}
                          </td>
                        </tr>
                      )}

                      {!!orderDetails?.details?.coach_first_name && (
                        <tr>
                          <td style={{ padding: "15px" }}>
                            Coach's First Name
                          </td>
                          <td
                            style={{
                              padding: "15px",
                              backgroundColor: "#f5f5f5",
                            }}
                          >
                            {orderDetails?.details.coach_first_name}
                          </td>
                        </tr>
                      )}

                      {!!orderDetails?.details?.coach_last_name && (
                        <tr>
                          <td style={{ padding: "15px" }}>Coach's Last Name</td>
                          <td
                            style={{
                              padding: "15px",
                              backgroundColor: "#f5f5f5",
                            }}
                          >
                            {orderDetails?.details.coach_last_name}
                          </td>
                        </tr>
                      )}

                      {orderDetails?.details
                        ?.have_scheduled_appointment_before !== null && (
                        <tr>
                          <td style={{ padding: "15px" }}>
                            Have you scheduled an appointment before?
                          </td>
                          <td
                            style={{
                              padding: "15px",
                              backgroundColor: "#f5f5f5",
                            }}
                          >
                            {orderDetails?.details
                              .have_scheduled_appointment_before
                              ? "Yes, I’m an existing patient"
                              : "No, I’m a new patient"}
                          </td>
                        </tr>
                      )}
                      {orderDetails?.details?.have_referral_from_doctor !==
                        null && (
                        <tr>
                          <td style={{ padding: "15px" }}>
                            Do you have a referral from a doctor?
                          </td>
                          <td
                            style={{
                              padding: "15px",
                              backgroundColor: "#f5f5f5",
                            }}
                          >
                            {orderDetails?.details.have_referral_from_doctor
                              ? "Yes"
                              : "No"}
                          </td>
                        </tr>
                      )}
                      {!!orderDetails?.details?.referral_doctor_name && (
                        <tr>
                          <td style={{ padding: "15px" }}>
                            If you have a referral, please enter your doctor's
                            name
                          </td>
                          <td
                            style={{
                              padding: "15px",
                              backgroundColor: "#f5f5f5",
                            }}
                          >
                            {orderDetails?.details.referral_doctor_name}
                          </td>
                        </tr>
                      )}
                      {!!orderDetails?.details?.how_did_you_hear_about_us && (
                        <tr>
                          <td style={{ padding: "15px" }}>
                            How did you hear about us?
                          </td>
                          <td
                            style={{
                              padding: "15px",
                              backgroundColor: "#f5f5f5",
                            }}
                          >
                            {orderDetails?.details.how_did_you_hear_about_us}
                          </td>
                        </tr>
                      )}
                      {orderDetails?.details?.receive_newsletter !== null &&
                        !isHarvardClient() && (
                          <tr>
                            <td style={{ padding: "15px" }}>
                              Would you like to receive our newsletter?
                            </td>
                            <td
                              style={{
                                padding: "15px",
                                backgroundColor: "#f5f5f5",
                              }}
                            >
                              {orderDetails?.details.receive_newsletter
                                ? "Yes"
                                : "No"}
                            </td>
                          </tr>
                        )}
                      {orderDetails?.details?.aqha_number !== null && (
                        <tr>
                          <td style={{ padding: "15px" }}>Enter your AQHA#:</td>
                          <td
                            style={{
                              padding: "15px",
                              backgroundColor: "#f5f5f5",
                            }}
                          >
                            {orderDetails?.details.aqha_number}
                          </td>
                        </tr>
                      )}
                      {orderDetails?.details?.receive_horseman_corral !==
                        null && (
                        <tr>
                          <td style={{ padding: "15px" }}>
                            Would you like to receive the Horseman's Corral?
                          </td>
                          <td
                            style={{
                              padding: "15px",
                              backgroundColor: "#f5f5f5",
                            }}
                          >
                            {orderDetails?.details.receive_horseman_corral
                              ? "Yes"
                              : "No"}
                          </td>
                        </tr>
                      )}

                      {orderDetails?.details?.family_members?.length > 0 && (
                        <tr>
                          <td style={{ padding: "15px" }}>Family Members:</td>
                          <td
                            style={{
                              padding: "15px",
                              backgroundColor: "#f5f5f5",
                            }}
                          >
                            {orderDetails?.details?.family_members ||
                              [].map((member, index) => {
                                return (
                                  <div key={index}>
                                    <span>
                                      First Name: {member?.first_name}
                                    </span>
                                    <br />
                                    <span>Last Name: {member?.last_name}</span>
                                    <br />
                                    <span>Email: {member?.email}</span>
                                    <br />
                                    <span>AQHA: {member?.aqha}</span>
                                    <br />
                                    <span>DOB: {member?.date_of_birth}</span>
                                    <br />
                                    <br />
                                  </div>
                                )
                              })}
                          </td>
                        </tr>
                      )}

                      {!!orderDetails?.details?.company_name && (
                        <tr>
                          <td style={{ padding: "15px" }}>Company Name</td>
                          <td
                            style={{
                              padding: "15px",
                              backgroundColor: "#f5f5f5",
                            }}
                          >
                            {orderDetails?.details?.company_name}
                          </td>
                        </tr>
                      )}

                      {!!orderDetails?.details?.languages && (
                        <tr>
                          <td style={{ padding: "15px" }}>Languages</td>
                          <td
                            style={{
                              padding: "15px",
                              backgroundColor: "#f5f5f5",
                            }}
                          >
                            {orderDetails?.details?.languages}
                          </td>
                        </tr>
                      )}
                      {!!orderDetails?.details?.location && (
                        <tr>
                          <td style={{ padding: "15px" }}>
                            Location / Travels from
                          </td>
                          <td
                            style={{
                              padding: "15px",
                              backgroundColor: "#f5f5f5",
                            }}
                          >
                            {orderDetails?.details?.location}
                          </td>
                        </tr>
                      )}

                      {!!orderDetails?.details?.bio && (
                        <tr>
                          <td style={{ padding: "15px" }}>Bio</td>
                          <td
                            style={{
                              padding: "15px",
                              backgroundColor: "#f5f5f5",
                            }}
                          >
                            {orderDetails?.details?.bio}
                          </td>
                        </tr>
                      )}
                      {!!orderDetails?.details?.years_experience && (
                        <tr>
                          <td style={{ padding: "15px" }}>Years Experience</td>
                          <td
                            style={{
                              padding: "15px",
                              backgroundColor: "#f5f5f5",
                            }}
                          >
                            {orderDetails?.details?.years_experience}
                          </td>
                        </tr>
                      )}
                      {!!orderDetails?.details?.area_of_expertise && (
                        <tr>
                          <td style={{ padding: "15px" }}>
                            Areas of Expertise
                          </td>
                          <td
                            style={{
                              padding: "15px",
                              backgroundColor: "#f5f5f5",
                            }}
                          >
                            {orderDetails?.details?.area_of_expertise}
                          </td>
                        </tr>
                      )}
                      {!!orderDetails?.details?.certifications && (
                        <tr>
                          <td style={{ padding: "15px" }}>Certifications</td>
                          <td
                            style={{
                              padding: "15px",
                              backgroundColor: "#f5f5f5",
                            }}
                          >
                            {orderDetails?.details?.certifications}
                          </td>
                        </tr>
                      )}
                      {!!orderDetails?.details?.fees && (
                        <tr>
                          <td style={{ padding: "15px" }}>Fees</td>
                          <td
                            style={{
                              padding: "15px",
                              backgroundColor: "#f5f5f5",
                            }}
                          >
                            {orderDetails?.details?.fees}
                          </td>
                        </tr>
                      )}
                      {!!orderDetails?.details?.offered_program && (
                        <tr>
                          <td style={{ padding: "15px" }}>Program Offered</td>
                          <td
                            style={{
                              padding: "15px",
                              backgroundColor: "#f5f5f5",
                            }}
                          >
                            {orderDetails?.details?.offered_program}
                          </td>
                        </tr>
                      )}
                      {!!orderDetails?.details?.partial_client_list && (
                        <tr>
                          <td style={{ padding: "15px" }}>
                            Partial client list
                          </td>
                          <td
                            style={{
                              padding: "15px",
                              backgroundColor: "#f5f5f5",
                            }}
                          >
                            {orderDetails?.details?.partial_client_list}
                          </td>
                        </tr>
                      )}
                      {!!orderDetails?.details?.ideal_time_to_meet && (
                        <tr>
                          <td style={{ padding: "15px" }}>
                            Ideal time to meet
                          </td>
                          <td
                            style={{
                              padding: "15px",
                              backgroundColor: "#f5f5f5",
                            }}
                          >
                            {orderDetails?.details?.ideal_time_to_meet}
                          </td>
                        </tr>
                      )}
                      {!!orderDetails?.details
                        ?.personal_goal_for_joining_a_forum && (
                        <tr>
                          <td style={{ padding: "15px" }}>
                            Personal goal for joining a forum
                          </td>
                          <td
                            style={{
                              padding: "15px",
                              backgroundColor: "#f5f5f5",
                            }}
                          >
                            {
                              orderDetails?.details
                                ?.personal_goal_for_joining_a_forum
                            }
                          </td>
                        </tr>
                      )}
                      {!!orderDetails?.details
                        ?.how_long_have_you_been_a_facilitator && (
                        <tr>
                          <td style={{ padding: "15px" }}>
                            How long have you been a facilitator?
                          </td>
                          <td
                            style={{
                              padding: "15px",
                              backgroundColor: "#f5f5f5",
                            }}
                          >
                            {
                              orderDetails?.details
                                ?.how_long_have_you_been_a_facilitator
                            }
                          </td>
                        </tr>
                      )}
                      {!!orderDetails?.details?.previous_forum_experience && (
                        <tr>
                          <td style={{ padding: "15px" }}>
                            Previous forum experience
                          </td>
                          <td
                            style={{
                              padding: "15px",
                              backgroundColor: "#f5f5f5",
                            }}
                          >
                            {orderDetails?.details?.previous_forum_experience}
                          </td>
                        </tr>
                      )}
                      {!!orderDetails?.details?.currently_in_a_forum && (
                        <tr>
                          <td style={{ padding: "15px" }}>
                            Are you currently in a forum?
                          </td>
                          <td
                            style={{
                              padding: "15px",
                              backgroundColor: "#f5f5f5",
                            }}
                          >
                            {orderDetails?.details?.currently_in_a_forum}
                          </td>
                        </tr>
                      )}
                      {!!orderDetails?.details
                        ?.interested_in_being_a_moderator && (
                        <tr>
                          <td style={{ padding: "15px" }}>
                            Would you be interested in being a moderator?
                          </td>
                          <td
                            style={{
                              padding: "15px",
                              backgroundColor: "#f5f5f5",
                            }}
                          >
                            {
                              orderDetails?.details
                                ?.interested_in_being_a_moderator
                            }
                          </td>
                        </tr>
                      )}
                      {!!orderDetails?.details?.forum_placement_preference && (
                        <tr>
                          <td style={{ padding: "15px" }}>
                            Forum placement preference
                          </td>
                          <td
                            style={{
                              padding: "15px",
                              backgroundColor: "#f5f5f5",
                            }}
                          >
                            {orderDetails?.details?.forum_placement_preference}
                          </td>
                        </tr>
                      )}
                      {!!orderDetails?.details?.harvard_affiliation && (
                        <tr>
                          <td style={{ padding: "15px" }}>
                            Harvard Affiliation
                          </td>
                          <td
                            style={{
                              padding: "15px",
                              backgroundColor: "#f5f5f5",
                            }}
                          >
                            {orderDetails?.details?.harvard_affiliation}
                          </td>
                        </tr>
                      )}
                      {!!orderDetails?.details?.harvard_school_department && (
                        <tr>
                          <td style={{ padding: "15px" }}>
                            If you are Harvard faculty/staff - Enter the Harvard
                            school or department
                          </td>
                          <td
                            style={{
                              padding: "15px",
                              backgroundColor: "#f5f5f5",
                            }}
                          >
                            {orderDetails?.details?.harvard_school_department}
                          </td>
                        </tr>
                      )}
                      {!!orderDetails?.details?.last_school_attended && (
                        <tr>
                          <td style={{ padding: "15px" }}>
                            Last Harvard School Attended
                          </td>
                          <td
                            style={{
                              padding: "15px",
                              backgroundColor: "#f5f5f5",
                            }}
                          >
                            {orderDetails?.details?.last_school_attended}
                          </td>
                        </tr>
                      )}
                      {!!orderDetails?.details?.degree && (
                        <tr>
                          <td style={{ padding: "15px" }}>
                            Harvard Degree/Program
                          </td>
                          <td
                            style={{
                              padding: "15px",
                              backgroundColor: "#f5f5f5",
                            }}
                          >
                            {orderDetails?.details?.degree}
                          </td>
                        </tr>
                      )}
                      {!!orderDetails?.details?.class_year && (
                        <tr>
                          <td style={{ padding: "15px" }}>Class Year (YYYY)</td>
                          <td
                            style={{
                              padding: "15px",
                              backgroundColor: "#f5f5f5",
                            }}
                          >
                            {orderDetails?.details?.class_year}
                          </td>
                        </tr>
                      )}
                      {!!orderDetails?.details?.current_situation && (
                        <tr>
                          <td style={{ padding: "15px" }}>
                            Type in the role or roles that currently describe(s)
                            you (answer N/A if none apply to you): Founder /
                            Working in a Start-up / Investor / C-suite Executive
                          </td>
                          <td
                            style={{
                              padding: "15px",
                              backgroundColor: "#f5f5f5",
                            }}
                          >
                            {orderDetails?.details?.current_situation}
                          </td>
                        </tr>
                      )}
                      {!!orderDetails?.details?.current_organisation && (
                        <tr>
                          <td style={{ padding: "15px" }}>
                            Current Organization
                          </td>
                          <td
                            style={{
                              padding: "15px",
                              backgroundColor: "#f5f5f5",
                            }}
                          >
                            {orderDetails?.details?.current_organisation}
                          </td>
                        </tr>
                      )}
                      {!!orderDetails?.details?.title && (
                        <tr>
                          <td style={{ padding: "15px" }}>Current Job Title</td>
                          <td
                            style={{
                              padding: "15px",
                              backgroundColor: "#f5f5f5",
                            }}
                          >
                            {orderDetails?.details?.title}
                          </td>
                        </tr>
                      )}
                      {!!orderDetails?.details?.social_media &&
                        isHarvardClient() && (
                          <tr>
                            <td style={{ padding: "15px" }}>
                              Linkedin Profile
                            </td>
                            <td
                              style={{
                                padding: "15px",
                                backgroundColor: "#f5f5f5",
                              }}
                            >
                              {orderDetails?.details?.social_media}
                            </td>
                          </tr>
                        )}
                      {!!orderDetails?.details?.chapter_attend_events && (
                        <tr>
                          <td style={{ padding: "15px" }}>
                            Please fill in a chapter where you would like to
                            attend events
                          </td>
                          <td
                            style={{
                              padding: "15px",
                              backgroundColor: "#f5f5f5",
                            }}
                          >
                            {orderDetails?.details?.chapter_attend_events}
                          </td>
                        </tr>
                      )}
                      {!!order?.details?.guest_speaker_question && (
                        <tr>
                          <td style={{ padding: "15px" }}>
                            Please submit your question for our guest speaker
                          </td>
                          <td
                            style={{
                              padding: "15px",
                              backgroundColor: "#f5f5f5",
                            }}
                          >
                            {order?.details?.guest_speaker_question}
                          </td>
                        </tr>
                      )}
                      {!!orderDetails?.details?.receive_newsletter &&
                        isHarvardClient() && (
                          <tr>
                            <td style={{ padding: "15px" }}>
                              I agree to receive the HarvardAE newsletter and
                              administrative emails
                            </td>
                            <td
                              style={{
                                padding: "15px",
                                backgroundColor: "#f5f5f5",
                              }}
                            >
                              {orderDetails?.details?.receive_newsletter
                                ? "Yes"
                                : "No"}
                            </td>
                          </tr>
                        )}
                      {isHarvardClient() && (
                        <tr>
                          <td style={{ padding: "15px" }}>
                            I agree to Terms and Conditions and Code of Conduct
                          </td>
                          <td
                            style={{
                              padding: "15px",
                              backgroundColor: "#f5f5f5",
                            }}
                          >
                            Yes
                          </td>
                        </tr>
                      )}
                      {isHarvardClient() && (
                        <tr>
                          <td style={{ padding: "15px" }}>
                            I certify that the information provided is true and
                            correct
                          </td>
                          <td
                            style={{
                              padding: "15px",
                              backgroundColor: "#f5f5f5",
                            }}
                          >
                            Yes
                          </td>
                        </tr>
                      )}
                      {isHarvardClient() && (
                        <tr>
                          <td style={{ padding: "15px" }}>
                            I acknowledge membership fees are nonrefundable
                          </td>
                          <td
                            style={{
                              padding: "15px",
                              backgroundColor: "#f5f5f5",
                            }}
                          >
                            Yes
                          </td>
                        </tr>
                      )}
                      {orderDetails?.tags?.length > 0 && (
                        <tr>
                          <td style={{ padding: "15px" }}>
                            {orderDetails?.product.user_tags_label
                              ? orderDetails?.product.user_tags_label
                              : "I am a"}
                            :
                          </td>
                          <td
                            style={{
                              padding: "15px",
                              backgroundColor: "#f5f5f5",
                            }}
                          >
                            {orderDetails?.tags?.map((tag, index) => {
                              return <span key={index}>{tag.tag} </span>
                            })}
                          </td>
                        </tr>
                      )}

                      {!!orderDetails?.product && (
                        <tr>
                          <td style={{ padding: "15px" }}>Product</td>
                          <td
                            style={{
                              padding: "15px",
                              backgroundColor: "#f5f5f5",
                            }}
                          >
                            {orderDetails?.product.name}
                          </td>
                        </tr>
                      )}
                      {orderDetails?.products?.length > 0 &&
                        !orderDetails?.product && (
                          <tr>
                            <td style={{ padding: "15px" }}>Products:</td>
                            <td
                              style={{
                                padding: "15px",
                                backgroundColor: "#f5f5f5",
                              }}
                            >
                              {orderDetails?.products?.map((product, index) => {
                                return (
                                  <div key={index}>
                                    <span>Product: {product.name}</span>
                                    <br />
                                    <span>Price: ${product?.price}</span>
                                    <br />
                                    <br />
                                  </div>
                                )
                              })}
                            </td>
                          </tr>
                        )}
                      {!!orderDetails.discount_amount && (
                        <tr style={{ fontSize: "16px" }}>
                          <td style={{ padding: "15px" }}>Discount</td>
                          <td
                            style={{
                              padding: "15px",
                              backgroundColor: "#f5f5f5",
                            }}
                          >
                            ${orderDetails?.discount_amount / 100 || 0}
                          </td>
                        </tr>
                      )}
                      <tr style={{ fontSize: "16px" }}>
                        <td style={{ padding: "15px" }}>
                          <b>orderDetails Total Paid</b>
                        </td>
                        <td
                          style={{
                            padding: "15px",
                            backgroundColor: "#f5f5f5",
                          }}
                        >
                          <b>${orderDetails?.amount / 100 || 0}</b>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </Col>
              </Row>
              {orderDetails?.stripe_subscription && (
                <>
                  <Row className="mt-3">
                    <Col>
                      <p>
                        If you want to do any changes for this subscription, you
                        have to go into the stripe dashboard and perform the
                        action there
                      </p>
                      <p>
                        <i>Subscription</i>
                      </p>
                      <p>Status: {orderDetails?.stripe_subscription?.status}</p>
                      <p>
                        <p>
                          Application fee percent:{" "}
                          {
                            orderDetails?.stripe_subscription
                              ?.application_fee_percent
                          }
                        </p>
                      </p>
                    </Col>
                  </Row>
                </>
              )}
              {orderDetails?.stripe_payment && (
                <>
                  <Row>
                    <Col>
                      <h3>Payment Details</h3>
                      <p></p>
                      {orderDetails?.stripe_payment &&
                        orderDetails?.stripe_payment
                          ?.connected_account_changed &&
                        ((orderDetails?.stripe_payment?.refunded_amount &&
                          orderDetails?.stripe_payment?.partial_refund) ||
                          !orderDetails?.stripe_payment?.refunded_amount) && (
                          <p>
                            !!! A refund can not be done from the dashboard
                            because the connected account has been changed.{" "}
                            <br />
                            You can do the refund only from the stripe
                            account(id:{" "}
                            <span>
                              <b>
                                {
                                  orderDetails?.stripe_payment
                                    ?.connected_account_id
                                }
                              </b>
                            </span>
                            ), where the payment was done.
                          </p>
                        )}
                      {orderDetails?.stripe_payment &&
                        orderDetails?.stripe_payment?.refunded_amount && (
                          <p>
                            <i>
                              {orderDetails?.stripe_payment?.partial_refund && (
                                <span>PARTIAL </span>
                              )}
                              REFUNDED
                              {orderDetails?.stripe_payment?.partial_refund && (
                                <span>
                                  ($
                                  {orderDetails?.stripe_payment
                                    ?.refunded_amount / 100}
                                  )
                                </span>
                              )}
                            </i>
                          </p>
                        )}

                      {orderDetails?.stripe_payment &&
                        orderDetails?.stripe_payment?.refund_status == 3 && (
                          <p>
                            <i>REFUNDING</i>
                          </p>
                        )}
                      {orderDetails?.stripe_payment &&
                        orderDetails?.stripe_payment.refunded_at && (
                          <p>
                            <b>
                              Refunded at:{" "}
                              <span>
                                {orderDetails?.stripe_payment?.refunded_at}
                              </span>
                            </b>
                          </p>
                        )}
                      <p>Order ID: {orderDetails?.id}</p>
                      <p>Date Ordered: {orderDetails?.created_at}</p>
                      {orderDetails?.stripe_payment && (
                        <div>
                          <div>
                            Billing:{" "}
                            <span>
                              {orderDetails?.stripe_payment?.billing_name}
                            </span>
                            <br />
                            <span>
                              {orderDetails?.stripe_payment?.billing_line1}{" "}
                              {orderDetails?.stripe_payment?.billing_line2}
                            </span>
                            <br />
                            <span>
                              {orderDetails?.stripe_payment?.billing_city}{" "}
                              {orderDetails?.stripe_payment?.billing_state}{" "}
                              {orderDetails?.stripe_payment?.billing_country}
                              {orderDetails?.stripe_payment?.postal_code}
                            </span>
                          </div>
                        </div>
                      )}
                      {orderDetails?.stripe_payment && (
                        <div>
                          Payment Method:&nbsp;
                          {orderDetails?.stripe_payment?.payment_method ==
                            1 && (
                            <span>
                              *** *** ***{" "}
                              {orderDetails?.stripe_payment.card_last4}
                            </span>
                          )}
                          {orderDetails?.stripe_payment?.payment_method ==
                            2 && <span>Apple Pay</span>}
                          {orderDetails?.stripe_payment?.payment_method ==
                            3 && <span>Google Pay</span>}
                        </div>
                      )}
                      <b />
                      <b />
                    </Col>
                  </Row>
                </>
              )}
              {orderDetails?.status != 3 &&
                orderDetails?.status != 1 &&
                orderDetails?.stripe_payment &&
                !orderDetails?.stripe_payment.connected_account_changed &&
                !orderDetails?.stripe_payment?.full_refund && (
                  <Row className="my-3">
                    <Col xs="auto">
                      <SaveButton
                        type="button"
                        color="danger"
                        content="Refund Order"
                      />
                    </Col>
                  </Row>
                )}
            </>
          )}
        </Container>
      </div>
    </React.Fragment>
  )
}

const mapStateToProps = state => ({
  orderDetails: state.ProductsAndSubscriptions.orderDetails,
  loading: state.ProductsAndSubscriptions.loading,
})

const mapDispatchToProps = dispatch => ({
  getOrderDetails: values => dispatch(getOrderDetails(values)),
  resetOrderDetails: () => dispatch(resetOrderDetails()),
})

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withRouter(OrderDetails))
